import { updateObject } from '../../components/cdl-react-components/utilities'
import { 
    UPDATE_SEARCH_PARAMETERS,
    UPDATE_SEARCH_RESULTS
} from '../actions/types'

const searchReducer = (state = { id: 0 }, action) => {
    const stateUpdates = () => {
        switch (action.type) {
            case UPDATE_SEARCH_PARAMETERS: return { parameters: action.payload, id: state.id + 1, searching: true, firstSearchComplete: true }
            case UPDATE_SEARCH_RESULTS: return { results: action.payload, searching: false }
            default: return {}
        }
    }

    return updateObject(state, stateUpdates())
}

export default searchReducer